import { render, staticRenderFns } from "./MobileData.vue?vue&type=template&id=0a02d858&scoped=true"
import script from "./MobileData.vue?vue&type=script&lang=js"
export * from "./MobileData.vue?vue&type=script&lang=js"
import style0 from "./MobileData.vue?vue&type=style&index=0&id=0a02d858&prod&lang=stylus&rel=stylesheet%2Fstylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a02d858",
  null
  
)

export default component.exports